



















































































































import { mapState } from 'vuex';
import * as vr from '@/helpers/validation';
import { getAvailableAccounts } from '@/api/SuperAdminRoles';
import { ERole } from '@/plugins/role-permissions/types';
import { Operation } from './SuperAdminRolesHelper';
import type { SuperAdminUser, AccountItem } from '@/api/schema';
import type { PropType } from 'vue';

interface TextContents {
  header: string;
  mainButton: string;
  secondButton: string;
}
const defaultTexts = {
  header: '',
  mainButton: '',
  secondButton: 'cancel'
};

export default {
  name: 'SuperAdminRolesDialog',
  data(): any {
    return {
      formIsValid: true,
      itemData: {},
      showPassword: false,
      accounts: [],
      roles: [
        {
          label: 'ADMIN',
          value: ERole.ROLE_ADMIN
        },
        {
          label: 'FINANCE',
          value: ERole.ROLE_FINANCE
        },
        {
          label: 'MANAGER',
          value: ERole.ROLE_MANAGER
        }
      ]
    };
  },
  props: {
    value: {
      type: Boolean as PropType<boolean>,
      default: (): boolean => false
    },
    processing: {
      type: Boolean as PropType<boolean>,
      default: (): boolean => false
    },
    item: {
      type: Object as PropType<SuperAdminUser>,
      default: (): SuperAdminUser => ({} as SuperAdminUser)
    },
    operation: {
      type: String as PropType<string>,
      default: (): string => ''
    }
  },
  computed: {
    ...mapState('Onboarding', ['operators']),
    operations(): { [key: string]: string } {
      return Operation;
    },
    isViewModal(): boolean {
      return this.operation === Operation.READ;
    },
    disableEmail(): boolean {
      return [Operation.UPDATE, Operation.READ].includes(this.operation);
    },
    showAccountsSelect(): boolean {
      return this.itemData.role === ERole.ROLE_MANAGER;
    },
    contents(): TextContents {
      switch (this.operation) {
        case 'create':
          return {
            ...defaultTexts,
            header: 'Add account',
            mainButton: 'create'
          };
        case 'update':
          return {
            ...defaultTexts,
            header: 'Edit',
            mainButton: 'Update'
          };
        case 'read':
          return {
            header: 'View',
            mainButton: 'Done',
            secondButton: 'Edit'
          };
        default:
          return { ...defaultTexts };
      }
    },
    show: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean): void {
        this.$emit('input', value);
      }
    },
    rules(): any {
      return {
        email: [vr.required, vr.isEmail],
        password: [vr.required, (v) => vr.minLength(v, 6)],
        role: [vr.required],
        accounts: [
          vr.required,
          (v) =>
            (v && v.length >= 1) || 'At least one account should be selected.'
        ]
      };
    },
    dataToSend(): Partial<SuperAdminUser> {
      const { role, accounts, login, password, id } = this.itemData;
      return {
        role,
        id,
        ...(this.showAccountsSelect && { accounts }),
        ...(!this.disableEmail && {
          login,
          password
        })
      };
    }
  },
  watch: {
    value(newValue: boolean): void {
      if (newValue) {
        this.$refs?.form?.reset?.();
        this.$nextTick(() => {
          this.itemData = { ...this.item };
        });
      }
    },
    showAccountsSelect(show: boolean): void {
      if (show) {
        this.getAccounts();
      }
    }
  },
  methods: {
    getAccountsList(): string[] {
      return (
        this.itemData?.accounts?.map((id: number): string | undefined => {
          const account = this.accounts.find(
            (item: AccountItem) => item.id === id
          );
          return account ? this.getAccountName(account) : undefined;
        }) ?? []
      );
    },
    getAccountName(data: AccountItem): string {
      return data?.brandName || data?.login || '';
    },
    getAccounts(): void {
      getAvailableAccounts().then((data: AccountItem[]): void => {
        this.accounts = [...data];
      });
    },
    submitHandler(): void {
      const form = this.$refs.form;
      form.validate();
      this.$nextTick((): void => {
        if (this.formIsValid) {
          this.$emit('submit', this.dataToSend);
        }
      });
    }
  }
};
